import { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { SuggestedWebsite } from '../../types/types';
import Popup from '../Popup/Popup';
import { getDisplayUrl } from '../../utils/common';
import { DataContext } from '../../App';

import checking from './checking.png';
import { ReactComponent as Loading } from './spinner-solid.svg';
import { ReactComponent as Checked } from './checked.svg';

import styles from './Onboarding.module.scss';

interface CheckingProps {
  toCheck: SuggestedWebsite[];
  next: () => void;
}

const Checking = ({ toCheck, next }: CheckingProps) => {
  const { staticData, refreshDashboards } = useContext(DataContext);
  const [done, setDone] = useState(new Array(toCheck.length).fill(false));
  const order = useMemo(() => orderOfChecking.filter((it) => it < toCheck.length), [toCheck]);

  const markAsChecked = useCallback(() => {
    order.forEach((timeout, i) => {
      setTimeout(() => {
        setDone((old) => old.map((val, idx) => (i === idx ? true : val)));
      }, timeout * 150);
    });
  }, [order]);

  useEffect(() => {
    if (toCheck.every(({ url }) => staticData.monitors.some((it) => it.data.url === url))) {
      markAsChecked();
      refreshDashboards();
    }
  }, [staticData, toCheck, markAsChecked]);

  useEffect(() => {
    if (done.every((it) => it)) {
      setTimeout(next, 1000);
    }
  }, [done, next]);

  return (
    <Popup show permanent title="checking websites...">
      <div className={styles.wrapper}>
        <p className={styles.intro}>
          Your <strong className="color-orange">Dashboard</strong> is ready soon. Please stand by,
          while we collect all the necessary information. It takes{' '}
          <strong className="color-orange">30 seconds</strong>.
        </p>
        <img src={checking} alt="Checking sites" />
        <div className={styles.sites}>
          {toCheck.map((site, idx) => (
            <div key={site.url} className={styles.siteCheckingWrapper}>
              {done[idx] ? <Checked /> : <Loading className={styles.loading} />}
              <span>{getDisplayUrl(site.url)}</span>
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
};

const orderOfChecking = [4, 2, 7, 1, 3, 9, 0, 8, 6, 5];

export default Checking;
